// extracted by mini-css-extract-plugin
export default {"button":"Button_button__nHJkq","blackButton":"Button_blackButton__kYzZi","whiteButton":"Button_whiteButton__BTNkS"};